<!-- 上传图片 -->
<template>
  <div class=''>
    <el-upload
      action="#"
      :http-request="uploadDetailPic"
      list-type="picture"
      :before-upload="beforeAvatarUpload"
      :show-file-list="false">
      <el-button v-if="!imageUrl" size="middle" type="default" class="upload-btn">上传图片
      </el-button>
      <ul class="pic-box" v-else>
        <li @mouseover="mouseAction(true)" @mouseout="mouseAction(false)">
          <img style="max-width: 300px;" :src="imageUrl | getImgUrl">
          <div class="mask" v-show="showMask">
            <div class="btn-box" @click.stop>
              <el-upload action="" :http-request="uploadDetailPic"
                         :before-upload="beforeAvatarUpload"
                         :show-file-list="false">
                <el-button type="primary" class="upload-tool-btn">替换</el-button>
              </el-upload>
              <div>
                <el-button type="danger" class="upload-tool-btn" @click="deletePic()"> 删除</el-button>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </el-upload>
  </div>
</template>
 
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'imageUpLoad',
    props: {
      // 图片数量限制
      url: {
        type: String,
        default: '',
      },
    },
    data() {
      //这里存放数据
      return {
        imageUrl: this.url,
        showMask: false,
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        // 关键：监听url的变化，同步更新到imageUrl
        url(newVal) {
          this.imageUrl = newVal;
        }
    },
    //方法集合
    methods: {
      //上传文件
      uploadDetailPic(file) {
        //检查文件格式
        file = file.file;
        const filename = file.name;
        const index = filename.split('.').pop().toLowerCase();
        this.apis.public.oss.onceClient({
          suffix: index,
          type: 'yxrs',
          file,
          progress: (percent, cpt) => {

          },
          success: (res) => {
            this.imageUrl = res.name;
            this.$emit('image-uploaded',this.imageUrl);
            this.toast.hide();
          },
          error: (err) => {
            this.toast.hide();
            this.toast.showWarning(err);
          }
        });
      },
      beforeAvatarUpload(file) {
        const filename = file.name
        const index = filename.split('.').pop().toLowerCase();//获取文件后缀
        return file
      },
      //删除图片
      deletePic(type) {
        this.imageUrl = '';
        // this.$emit("update:url", this.imageUrl);
        this.$emit('image-uploaded', this.imageUrl);
      },
      //鼠标动作
      mouseAction(isShow) {
        this.showMask = isShow;
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
 
    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
 
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>
 
<style lang='scss' scoped>
 
</style>


// WEBPACK FOOTER //
// src/components/ImageUpload/ImageUpload.vue